import { BaseQueryParams } from '../common/models/base-query-params';
import { CountryResponse } from '../common/models/country';
import { Paginated } from '../common/models/paginated';
import { buildBasicPaginatedSearchParams } from '../common/utils/url-search-params.helper';
import { apiPaths } from '../config/apiPaths';
import axiosInstance from './axios';

export const getCountries = async ({ q, page, limit }: BaseQueryParams): Promise<Paginated<CountryResponse>> => {
  const searchParams = buildBasicPaginatedSearchParams(page, limit, q);
  const { data } = await axiosInstance.get<Paginated<CountryResponse>>(apiPaths.COUNTRIES_PATH, {
    params: searchParams,
  });
  return data;
};
